// import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const rootElement = document.getElementById("root") as HTMLElement;
rootElement.className = "notranslate";

const root = ReactDOM.createRoot(rootElement);

root.render(<App />);
